import { Badge, Card, HStack, Text, VStack } from '@chakra-ui/react'
import { LuPaperclip } from 'react-icons/lu'

export type NotificationCardProps = {
  title: string
  message: string
  dateLabel: string
  isRead: boolean
  attachmentsCount?: number
  selected?: boolean
  onClick?: () => void
}

export function NotificationCard({
  title,
  message,
  dateLabel,
  isRead,
  attachmentsCount = 0,
  selected = false,
  onClick,
}: NotificationCardProps) {
  const bg = selected ? 'bg.info' : isRead ? 'bg.muted' : 'bg.default'

  return (
    <Card.Root
      as="button"
      textAlign="left"
      width="100%"
      borderColor="border"
      bg={bg}
      cursor="pointer"
      onClick={onClick}
      _hover={{ bg: 'bg.subtle' }}
    >
      <Card.Body>
        <HStack justify="space-between" align="start" gap={3}>
          <VStack align="start" gap={2} flex={1}>
            <HStack w="full" align="start" justifyContent="space-between" gap={2}>
              <Card.Title>{title}</Card.Title>
              {!isRead && <Badge colorPalette="purple">Neu</Badge>}
            </HStack>
            <Card.Description>{message}</Card.Description>
          </VStack>
        </HStack>

        <HStack justify="space-between" mt={3}>
          <Text textStyle="metadata" color="fg.muted">
            {dateLabel}
          </Text>

          <HStack gap={2} color="fg.muted">
            <LuPaperclip />
            <Text textStyle="metadata">{attachmentsCount}</Text>
          </HStack>
        </HStack>
      </Card.Body>
    </Card.Root>
  )
}
